import { forwardRef, useState } from "react";
import { View } from "react-native-web";
import { jsx, jsxs } from "react/jsx-runtime";
const getSelectedItem = ({
  items,
  key,
  value
}) => {
  let idx = items.findIndex((item) => item.key && key ? item.key === key : item.value === value);
  return idx === -1 && (idx = 0), items[idx] || {};
}, PickerSelect = ({
  disabled,
  style,
  pickerProps,
  Icon,
  items,
  placeholder,
  itemKey,
  value,
  onValueChange
}) => {
  const allItems = [placeholder].concat(items), [selectedItem, setSelectedItem] = useState(
    getSelectedItem({ items: allItems, key: itemKey, value })
  ), handleValueChange = (value2) => {
    const selectedItem2 = getSelectedItem({ items: allItems, value: value2 });
    setSelectedItem(selectedItem2), onValueChange(selectedItem2.value);
  };
  return /* @__PURE__ */ jsxs(
    View,
    {
      style: [
        {
          alignSelf: "stretch"
        },
        style?.viewContainer
      ],
      children: [
        /* @__PURE__ */ jsx(
          Picker,
          {
            style: style?.inputWeb,
            enabled: !disabled,
            onValueChange: handleValueChange,
            selectedValue: selectedItem.value,
            ...pickerProps,
            children: allItems.map((item) => /* @__PURE__ */ jsx("option", { value: item.value, label: item.label, children: item.label }, item.key))
          }
        ),
        /* @__PURE__ */ jsx(IconComponent, { Icon, style })
      ]
    }
  );
}, IconComponent = ({ Icon, style }) => Icon ? /* @__PURE__ */ jsx(
  View,
  {
    style: [
      {
        position: "absolute",
        right: 0
      },
      style?.iconContainer
    ],
    children: /* @__PURE__ */ jsx(Icon, {})
  }
) : null, Select = forwardRef(function(props, forwardedRef) {
  return /* @__PURE__ */ jsx("select", { ...props, ref: forwardedRef });
}), Picker = forwardRef(function({ enabled, onValueChange, selectedValue, children, ...other }, forwardedRef) {
  return /* @__PURE__ */ jsx(
    Select,
    {
      disabled: enabled === !1 ? !0 : void 0,
      onChange: (e) => {
        const { selectedIndex, value } = e.target;
        onValueChange && onValueChange(value, selectedIndex);
      },
      ref: forwardedRef,
      value: selectedValue,
      ...other,
      children
    }
  );
});
export {
  PickerSelect
};
